<p>cadastrar-frequencia-aluno works!</p>
